/**
 * DP48c — the phase badge on a project card prints an ABBREVIATION. The removed
 * fixed phase lists carried one per phase; a project's own phases carry only a
 * name, so the short is DERIVED from the name's capital letters. Nothing is
 * invented and no phase name is hardcoded.
 *
 * Client Onboarding CO · PreDesign PD · Pre-Design PD · Schematic Design SD ·
 * Design Development DD · Construction Documents CD · Contract Negotiation CN ·
 * Construction Administration CA · Project Closeout PC.
 */
export const phaseShort = (name) => {
  const caps = String(name || '').replace(/[^A-Za-z ]/g, ' ').match(/[A-Z]/g) || [];
  if (caps.length >= 2) return caps.slice(0, 3).join('');
  const word = String(name || '').trim();
  return word ? word.slice(0, 2).toUpperCase() : '—';
};

export default phaseShort;
